import '../style/footer.css';

export const Footer = () => {
  return (
    <div className='footer'>
        <p className='text-footer'>Transportes Saldivar</p>
        <p className='text-footer'>Todos los derechos reservados</p>
        <p className='text-footer'>saldivar.transportes@hotmail.com</p>
        <p className='text-footer'>(+52) 3310413175</p>
    </div>
  )
}
